import React from 'react';
import { withStyles } from '@material-ui/styles';
import TextColumns from './TextColumns';
import styleConstants from '../../../styleConstants';

const styles = {
	container: {
		padding: `2rem 2rem ${styleConstants.componentSpacing}`
	}
};

const TextOnly = props => (
	<div className={props.classes.container}>
		{props.sectionHeading ? (
			<h3 className="section-heading">{props.sectionHeading}</h3>
		) : null}
		{props.subSectionHeading ? (
			<h4 className="subsection-heading">{props.subSectionHeading}</h4>
		) : null}
		<TextColumns>{props.children}</TextColumns>
	</div>
);

export default withStyles(styles)(TextOnly);
